module.exports = __webpack_public_path__ + "static/img/balloons.1139b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/balloons.png
// module id = uYFl
// module chunks = 0